import { FC } from 'react';
import { faCameraLight } from '~/assets';
import { DOC_TYPES } from '~/utils';
import {
  ButtonOk,
  Description,
  DescriptionBold,
  ModalIcon,
  Title,
  Wrapper,
} from './styles';

type Props = {
  isOpen: boolean;
  handleDocumentSelection: (docType: DOC_TYPES) => void;
};

const ModalDocumentInstructions: FC<Props> = ({
  isOpen,
  handleDocumentSelection,
}) => {
  return (
    <Wrapper isOpen={isOpen} closeOnOverlayClick>
      <ModalIcon icon={faCameraLight} />
      <Title>Agora escolha um documento e tire uma foto</Title>
      <Description>
        <DescriptionBold>Retire</DescriptionBold> seu documento do{' '}
        <DescriptionBold>plástico</DescriptionBold>
        <br />
        <DescriptionBold>Alinhe</DescriptionBold> as informações{' '}
        <DescriptionBold>com a guia</DescriptionBold>
        <br />
        Verifique se as{' '}
        <DescriptionBold>informações estão legíveis</DescriptionBold>
        <br />
        Primeiro, capture a foto da{' '}
        <DescriptionBold>frente do documento</DescriptionBold> e, em seguida,
        capture a foto do <DescriptionBold>verso</DescriptionBold>.
      </Description>
      <ButtonOk
        id="btn_ok"
        onPress={() => handleDocumentSelection(DOC_TYPES.IDENTITY_CARD_FRONT)}
        fullWidth
      >
        RG
      </ButtonOk>
      <ButtonOk
        id="btn_ok"
        onPress={() => handleDocumentSelection(DOC_TYPES.DRIVER_LICENSE_FRONT)}
        fullWidth
      >
        CNH
      </ButtonOk>
    </Wrapper>
  );
};

export default ModalDocumentInstructions;
